<template lang="pug">
  fieldset.option-select.option-select--buttons(:class="`option-select--${label.toLowerCase()}`")
    legend.option-select__legend(v-if="label")
      span.option-select__legend--title {{ labelText }}
      span.option-select__legend--selection(v-if="label === 'Color'") {{ value }}
      a.option-select__legend--size-guide-link(v-if="label === 'Size'" href="#" title="Open Size Guide") Size Guide
    .option-select__label-wrapper
      label.option-select__label(
        v-for="option in optionSet"
        tabindex="0"
        :class="{ 'is-selected': option.value === value }"
      )
        span.option-select__label-text(v-if="label !== 'Color'") {{ option.value }}
        option-swatch(:option="option")
        input.u-sr-only(
          type="radio"
          tabindex="-1"
          v-model="currentValue"
          :id="option.label"
          :value="value"
          :disabled="option.disabled"
          :name="option"
          @change.prevent="onChange(option.value)"
        )
</template>

<script>
  import OptionSwatch from 'scripts/components/forms/OptionSwatch.vue';
  import { uniqueArray } from 'scripts/helpers/util.js';

  export default {
    name: 'ProductOption',
    components: {
      OptionSwatch,
    },
    props: {
      product: Object,
      label: String,
      value: String,
      option: {
        type: String,
        default: 'option1',
        validator(val) {
          return ['option1', 'option2', 'option3'].includes(val);
        },
      },
    },
    data() {
      return {
        currentValue: this.value,
      };
    },
    computed: {
      labelText() {
        return this.label === 'Color' ? `${this.label}:` : this.label;
      },
      optionSet() {
        const variantsObjects = this.product.variants.slice().map((variant) => {
          return {
            option: variant[this.option],
            image: this.option === 'option2' ? variant.image.src : '',
          };
        });
        return uniqueArray(variantsObjects).map((variant) => {
          return { label: this.label, value: variant.option, image: variant.image };
        });
      },
    },
    mounted() {
      const initialValue = this.value && this.value !== '' ? this.value : this.optionSet[0].value;
      this.$emit('input', initialValue);
    },
    methods: {
      onChange(value) {
        this.$emit('input', value);
      },
    },
  };
</script>

<style scoped lang="scss">
  .option-select {
    margin-bottom: $spacing-unit * 6;
    padding: 0;
    border: none;
  }

  .option-select__legend {
    margin-bottom: 10px;
    font-size: rem(16);
    font-weight: 500;
    line-height: rem(20);
    text-transform: capitalize;

    .option-select--size & {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }
  }

  .option-select__legend--size-guide-link {
  }

  .option-select__label-wrapper {
    .option-select--size & {
      margin-right: -12px;
    }
  }

  .option-select__label {
    display: inline-block;
    position: relative;
    border: 1px solid $color-primary-500;
    background-color: $color--secondary;
    cursor: pointer;
    font-size: rem(13);
    font-weight: 500;
    line-height: 22px;
    text-align: center;
    text-transform: uppercase;
    transition: 0.2s ease-in-out;

    &.is-selected {
      margin-bottom: -1px;
      margin-top: -1px;
      border-color: $color-black;
      border-width: 2px;
    }

    .option-select--size & {
      width: calc(25% - 12px);
      min-width: 90px;
    }

    &:hover {
      border-color: $color-black;
    }

    &:not(:last-child) {
      margin-right: 10px;

      @include tablet-up {
        margin-right: 12px;
      }
    }
  }

  .option-select__label-text {
    position: absolute;
    bottom: 0;
    left: 50%;
    font-size: rem(14px);
    line-height: rem(18px);
    transform: translateX(-50%);

    @include tablet-up {
      font-size: rem(16px);
      line-height: rem(20px);
    }
  }
</style>
